import { Component, OnInit, ViewChild ,Input} from '@angular/core';
import { GridBaseCase } from '../grid/grid.base.case';
import { WebParameterContext } from '../../../model/common';
import { Platform, IonInfiniteScroll, ModalController } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../service/messageclient.service';
declare var app;
@Component({
  selector: 'app-listof-activities',
  templateUrl: './listof-activities.page.html',
  styleUrls: ['./listof-activities.page.scss'],
})
export class ListofActivitiesPage extends GridBaseCase implements OnInit {
  activityListArray:Array<any>=[];
  _type:"";
  seceltName:string=""; // 选择的名字
  activeid:any;//活动
  FK_TBReasonsProductInventoryDifferences_ID:string="";// 选择的id
  arrListNumber:number=0;
  @Input() activityListArrayList:any;
  @Input() type:any;
  @Input() activeID:any;
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public modalController: ModalController,
  ) { 
    super();
  }

  ngOnInit() {
    const that=this;
    that.activeid = that.activeID;
    that.activityListArray = that.activityListArrayList;
    that.arrListNumber=that.activityListArray.length;
    console.log(this.activityListArrayList);
    that.activityListArray.forEach(items=>{
      items["isCheck"]= false;
      if(that.activeid == items.FK_TBActivity_ID){
        items["isCheck"]= true;
      }
    });
    console.log(that.activityListArray.length)
  }
  EventSelect(item){
    const that =this;
    // item.isCheck =false;
    that.activityListArray.forEach(items=>{
      items["isCheck"]= false;
      if(item.FK_TBActivity_ID == items.FK_TBActivity_ID){
        items["isCheck"]= true;
      }
    });
    that.seceltName =item.ActivityCode;
    that.FK_TBReasonsProductInventoryDifferences_ID = item.FK_TBActivity_ID
    
  }
    // 取消
    dismissModal() {
      const that=this;
      this.modalController.dismiss({
        "modalStatus": false,
        "type": that._type,
        "info": '0',
        "cravingforRemk":"",
        "seceltName":"",
        backurl:"1"
      });
    }
    // 确定
    comfireModal() {
        const that=this;
          that.modalController.dismiss({
          "modalStatus": true,
          "type": that._type,
          "info": "是的",
          "seceltName":that.seceltName,
          "FK_TBReasonsProductInventoryDifferences_ID":that.FK_TBReasonsProductInventoryDifferences_ID
        });
         
    }
}
